import { Component, inject, signal, computed } from "@angular/core";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { toSignal } from "@angular/core/rxjs-interop";
import { TabsModule } from "primeng/tabs";
import { SkeletonModule } from "primeng/skeleton";
import { SelectModule } from "primeng/select";
import { MainBtnComponent } from "../../../shared/UI/main-btn/main-btn.component";
import { FormsModule } from "@angular/forms";
import { CurriculumsService } from "../../services/curriculum/curriculums.service";
import { NgIcon, provideIcons } from "@ng-icons/core";
import { heroUsers } from "@ng-icons/heroicons/outline";
import { bootstrapChevronRight } from "@ng-icons/bootstrap-icons";

@Component({
  selector: "app-curriculum-tabs",
  standalone: true,
  imports: [TabsModule, RouterLink, SelectModule, FormsModule, SkeletonModule, MainBtnComponent],
  viewProviders: [provideIcons({ heroUsers, bootstrapChevronRight })],

  templateUrl: "./curriculum-tabs.component.html",
  styleUrls: ["./curriculum-tabs.component.css"],
})
export class CurriculumTabsComponent {
  private router = inject(Router);
  private _activatedRoute = inject(ActivatedRoute);
  private _curriculumsService = inject(CurriculumsService);
  routerData = toSignal(this._activatedRoute.data);
  // curriculumsTab = toSignal(this._curriculumsService.getCurriclums());
  curriculumsTab = computed(() => this.routerData()?.["data"]);

  selectedSlug = signal<string | null>(this._activatedRoute.snapshot.queryParamMap.get("selected"));
  boardSlug = signal<string | null>(this._activatedRoute.snapshot.queryParamMap.get("board"));
  isLoading = signal<boolean>(true);
  isLoadingTabs = signal<boolean>(true);

  timingTabs = setInterval(() => {
    const data = this.curriculumsTab()?.data;
    if (data && data?.length > 0) {
      this.isLoadingTabs.set(false);
      clearInterval(this.timingTabs);
      return;
    }
  }, 300);
  // timing = setInterval(() => {
  //   const data = this.curriculums()?.data;
  //   if (data && data?.length > 0) {
  //     this.isLoading.set(false);
  //     clearInterval(this.timing);
  //     return;
  //   }
  // }, 300);

  selectedTabId = computed(() => {
    const selected = this.selectedSlug();
    const data = this.curriculumsTab()?.data;
    if (!data || data?.length === 0) {
      return 0;
    }
    if (!selected) return data[0]?.id;
    const match = data?.find((c: any) => c.slug === selected);
    return match?.id || data[0]?.id;
  });

  selectedBoardId = computed(() => {
    const selectedBoardSlug = this.boardSlug();
    const selectedCurriculumId = this.selectedTabId();
    const curriculums = this.curriculumsTab()?.data;
    if (!curriculums || curriculums.length === 0) return 0;
    const currentCurriculum = curriculums.find((c: any) => c.id === selectedCurriculumId);
    if (!currentCurriculum || !currentCurriculum.boards?.length) return 0;
    const match = currentCurriculum.boards.find((b: any) => b.slug === selectedBoardSlug);
    if (!match) {
      const firstBoard = currentCurriculum.boards[0];
      if (firstBoard) {
        queueMicrotask(() => this.boardSlug.set(firstBoard.slug));
        return firstBoard.id;
      }
      return 0;
    }
    return match.id;
  });

  goToSubject(curriculumSlug: string, subjectSlug: string, boardSlug: string, boardTitle: string) {
    this.router.navigate(["/curriculum", curriculumSlug, "subject", subjectSlug], {
      queryParams: { board_slug: boardSlug, board_title: boardTitle },
      queryParamsHandling: "merge",
    });
  }

  onImgError(event: Event) {
    (event.target as HTMLImageElement).src = "Icons/star.png";
  }

  onCurriculumChange(slug: string) {
    this.selectedSlug.set(slug);
    this.router.navigate([], {
      queryParams: { selected: slug },
      queryParamsHandling: "merge",
    });
  }

  expandCard(card: HTMLElement) {
    if (window.innerWidth >= 768) {
      // فقط XL screens
      card.style.height = card.scrollHeight + "px";
    }
  }

  collapseCard(card: HTMLElement) {
    if (window.innerWidth >= 1024) {
      card.style.height = "12rem";
    }

    if (window.innerWidth <= 1024) {
      card.style.height = "10.5rem";
    }
    if (window.innerWidth <= 768) {
      card.style.height = card.scrollHeight + "px";
    }
  }
}
